import * as apiCommon from '@/api/apiCommon'

// 首页
const apiName = '/webapi'

// 获取变灰
export function readChange() {
    return apiCommon.index(apiName + '/base_parameter/readChange')
}

// 获取首页视频
export function getvideo(data) {
    return apiCommon.index(apiName + '/base_parameter/video', data)
}

// 获取公司概况
export function readCompany(data) {
    return apiCommon.index(apiName + '/base_parameter/read', data)
}
// 公司简介
export function readNews(data) {
    return apiCommon.index(apiName + '/news/index', data)
}
// 党建要闻
export function party_building(data) {
    return apiCommon.index(apiName + '/party_building/index', data)
}
// 合作方
export function partner(data) {
    return apiCommon.index(apiName + '/partner/index', data)
}

// 党建read news/read
export function party_building_read(data) {
    return apiCommon.index(apiName + '/party_building/read', data)
}
// 新闻read
export function news_read(data) {
    return apiCommon.index(apiName + '/news/read', data)
}
// 轮播图
export function banner_read(data) {
    return apiCommon.index(apiName + '/banner/index', data)
}